import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MainMenuService } from 'client/app/main/services/menuservice.service';

@Injectable({
    providedIn: 'root'
})
export class CommonReportService {

    private baseUrl = '/api/CommonReports';
    busy: Subscription;
    public unitInfo: any;
    public userInfo: any;

    constructor(@Inject(HttpClient) private http: HttpClient) {
        this.http = http;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.userInfo = JSON.parse(localStorage.getItem('user') as any);
    }

    OpenJasperReport(param, PrintType, registerId = 1) {
        const url = `${this.baseUrl}/JasperReport`;
        param.registerId = registerId;
        this.http.post(url, param)
            .subscribe(response => {
                var filename = '';
                //   console.log('response');
                //   console.log(response);
                if (response) {
                    var error = '';
                    error = response["error"];
                    //   console.log('error:'+error);
                    filename = response["FilePath"];
                    if (filename.length > 0) {
                        if (PrintType == 'print') {
                            $('<iframe>', {
                                name: 'IFramePdfPrint',
                                class: 'printFrame',
                                src: filename,
                                style: 'display:none',
                            }).appendTo('body');
                            window.frames['IFramePdfPrint'].focus();
                            window.frames['IFramePdfPrint'].print();
                        } else if (PrintType == 'preview') {
                            window.open(filename, '_blank');
                        }
                    }
                }
            });
    }

    GetJasperReport(param, registerId = 1): Observable<any> {
        param.params.CompanyId = this.unitInfo.Company_ID;
        param.params.UnitId = this.unitInfo.Unit_ID;
        param.params.FinYear = this.unitInfo.Fyear;
        param.registerId = registerId;
        const url = `${this.baseUrl}/JasperReport`;
        return this.http.post(url, param).pipe(
            map((data: any[]) => data),
        );
    }

    GetJasperReportTransaction(param, registerId = 3): Observable<any> {
        param.params.CompanyId = this.unitInfo.Company_ID;
        param.params.UnitId = this.unitInfo.Unit_ID;
        param.params.FinYear = this.unitInfo.Fyear;
        param.registerId = registerId;
        const url = `${this.baseUrl}/JasperReport`;
        return this.http.post(url, param).pipe(
            map((data: any[]) => data),
        );
    }

    GetPaymentVoucherExcel(param): Observable<any> {
        param.params.CompanyId = this.unitInfo.Company_ID;
        param.params.UnitId = this.unitInfo.Unit_ID;
        param.params.FinYear = this.unitInfo.Fyear;
        const url = `${this.baseUrl}/PaymentVoucherExcel`;
        return this.http.post(url, param).pipe(
            map((data: any[]) => data),
        );
    }

    GetJasperReportForMRUser(param, registerId = 1): Observable<any> {
        param.params.CompanyId = this.userInfo.Company_ID;
        param.params.UnitId = this.userInfo.Unit_ID;
        param.params.FinYear = this.unitInfo.Fyear;
        param.registerId = registerId;
        const url = `${this.baseUrl}/JasperReport`;
        return this.http.post(url, param).pipe(
            map((data: any[]) => data),
        );
    }
}